<template>
  <div class="bt-home pb-5">
    <div class="d-flex backCustomSatu" style="height: 410px; border-radius: 0 0 30px 30px"></div>
    <div style="margin-top: -420px"></div>
    <div class="mx-3 d-flex justify-center align-center">
      <h6 class="text-subtitle-1 font-weight-bold" style="color: rgba(255, 255, 255, 0.7); z-index: 1">{{
        this.user.branch_name }}</h6>
    </div>
    <JadwalSholat />
    <div style="margin-top: 0px"></div>
    <v-col class="px-3 py-3" cols="12">
      <v-btn @click="startDownload" height="50" width="100%"
        class="rounded-pill white--text font-weight-bold text-subtitle-1 neumorphic-btn bg-gradient transition-all relative overflow-hidden">
        <v-icon left class="text-h5 animate-bounce">mdi-file-download</v-icon>
        <h5>ambil Data</h5>
      </v-btn>
      <v-dialog v-model="isDialogVisible" persistent max-width="400">
        <v-card class="pa-3 rounded-xl">
          <v-card-title class="headline d-flex justify-center align-center">
            <v-icon color="grey" class="text-h2" v-if="progress < 100">mdi-cloud-download-outline</v-icon> <v-icon
              color="grey" class="text-h2" v-else>mdi-cloud-check-variant</v-icon></v-card-title>
          <v-card-text>
            <p class="d-flex justify-center align-center" v-if="progress < 100">Mohon tunggu, Sedang mengambil data...
            </p>
            <p class="d-flex justify-center align-center" v-else>Data berhasil diambil</p>

            <v-progress-linear v-if="isLoading" color="var(--primary)" :value="progress" height="20" striped rounded>
              <template v-slot:default="{ value }">
                <strong class="py-2" style="color: white !important">{{ Math.ceil(value) }}%</strong>
              </template>
            </v-progress-linear>
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn class="rounded-lg green--text" small v-if="progress >= 100" @click="handleSelesai"><v-icon small
                class="mr-2">mdi-check-all</v-icon> selesai </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col class="mb-5" cols="12">
      <div class="card-container" :style="{
        backgroundColor: $vuetify.theme.dark ? 'var(--dark-bg)' : 'var(--light-bg)',
      }">
        <div class="card-item">
          <img src="@/assets/icon/pembukaan_tab.png" class="card-icon" alt="Expense Icon" />
          <div>
            <div class="card-text">Saldo Awal</div>
            <div class="card-value">{{ thousand(kasPetugas.saldoAwal) }}</div>
          </div>
        </div>
        <div class="card-item ml-4">
          <img src="@/assets/icon/pencairan_tab.png" class="card-icon" alt="Income Icon" />
          <div>
            <div class="card-text">Saldo Akhir</div>
            <div class="card-value">{{ thousand(kasPetugas.saldoAkhir) }}</div>
          </div>
        </div>
      </div>
      <div class="card-container mt-3" :style="{
        backgroundColor: $vuetify.theme.dark ? 'var(--dark-bg)' : 'var(--light-bg)',
      }">
        <div class="card-item">
          <img src="@/assets/icon/kas_masuk.png" class="card-icon" alt="Expense Icon" />
          <div>
            <div class="card-text">Kas Masuk</div>
            <div class="card-value">{{ thousand(kasPetugas.kasMasuk) }}</div>
          </div>
        </div>
        <div class="card-item ml-4">
          <img src="@/assets/icon/kas_keluar.png" class="card-icon" alt="Income Icon" />
          <div>
            <div class="card-text">Kas Keluar</div>
            <div class="card-value">{{ thousand(kasPetugas.kasKeluar) }}</div>
          </div>
        </div>
      </div>
    </v-col>
    <div class="px-3 mb-5 d-flex flex-column align-center">
      <v-row>
        <!-- PEMBIAYAAN -->
        <v-col cols="12">
          <v-card class="pt-5 pb-2 px-2 rounded-lg" :style="{
            backgroundColor: $vuetify.theme.dark ? 'var(--dark-bg)' : 'var(--light-bg)',
          }">
            <h4 class="text-subtitle-2 font-weight-bold rounded-lg px-3">Pembiayaan</h4>
            <v-divider class="ma-3" style="border-color: #ff9b6a"></v-divider>
            <div class="d-flex align-center rounded-lg mt-2 px-2 py-0 bg-grey position-relative">
              <v-col cols="6" class="d-flex align-center">
                <div class="mr-4">
                  <v-icon color="green darken-2" class="align-center" large> mdi-receipt-text-edit </v-icon>
                </div>
                <div>
                  <div class="font-weight-bold">{{ this.pembiayaan.pengajuan }}</div>
                  <div class="text-caption text--secondary">Pengajuan</div>
                </div>
              </v-col>
              <div class="separator"></div>
              <v-col cols="6" class="d-flex align-center">
                <div class="mr-4">
                  <v-icon color="red darken-2" class="align-center" large> mdi-receipt-text-send </v-icon>
                </div>
                <div>
                  <div class="font-weight-bold">{{ this.pembiayaan.pencairan }}</div>
                  <div class="text-caption text--secondary">Pencairan</div>
                </div>
              </v-col>
            </div>
          </v-card>
        </v-col>
        <!-- END PEMBIAYAAN -->

        <!-- TABUNGAN -->
        <v-col cols="12">
          <v-card class="pt-5 pb-2 px-2 rounded-lg" :style="{
            backgroundColor: $vuetify.theme.dark ? 'var(--dark-bg)' : 'var(--light-bg)',
          }">
            <h4 class="text-subtitle-2 font-weight-bold rounded-lg px-3">Tabungan</h4>
            <v-divider class="ma-3" style="border-color: #ff9b6a"></v-divider>
            <div class="d-flex align-center rounded-lg mt-2 px-2 py-0 bg-grey position-relative">
              <v-col cols="6" class="d-flex align-center">
                <div class="mr-4">
                  <v-icon color="green darken-2" class="align-center" large> mdi-cash-plus </v-icon>
                </div>
                <div>
                  <div class="font-weight-bold">{{ this.tabungan.pembukaan }}</div>
                  <div class="text-caption text--secondary">Pembukaan</div>
                </div>
              </v-col>
              <div class="separator"></div>
              <v-col cols="6" class="d-flex align-center">
                <div class="mr-4">
                  <v-icon color="red darken-2" class="align-center" large> mdi-transfer </v-icon>
                </div>
                <div>
                  <div class="font-weight-bold">{{ this.tabungan.pencairan }}</div>
                  <div class="text-caption text--secondary">Pencairan</div>
                </div>
              </v-col>
            </div>
          </v-card>
        </v-col>
        <!-- END TABUNGAN -->

        <!-- ANGGOTA -->
        <v-col cols="12">
          <v-card class="pt-5 pb-2 px-2 rounded-lg" :style="{
            backgroundColor: $vuetify.theme.dark ? 'var(--dark-bg)' : 'var(--light-bg)',
          }">
            <h4 class="text-subtitle-2 font-weight-bold rounded-lg px-3">Anggota</h4>
            <v-divider class="ma-3" style="border-color: #ff9b6a"></v-divider>
            <div class="d-flex align-center rounded-lg mt-2 px-2 py-0 bg-grey position-relative">
              <v-col cols="6" class="d-flex align-center">
                <div class="mr-4">
                  <v-icon color="green darken-2" class="align-center" large> mdi-arrow-up-right </v-icon>
                </div>
                <div>
                  <div class="font-weight-bold">{{ this.anggota.gabung }}</div>
                  <div class="text-caption text--secondary">Gabung</div>
                </div>
              </v-col>
              <div class="separator"></div>
              <v-col cols="6" class="d-flex align-center">
                <div class="mr-4">
                  <v-icon color="red darken-2" class="align-center" large> mdi-arrow-down-left </v-icon>
                </div>
                <div>
                  <div class="font-weight-bold">{{ this.anggota.keluar }}</div>
                  <div class="text-caption text--secondary">Keluar</div>
                </div>
              </v-col>
            </div>
          </v-card>
        </v-col>
        <!-- END ANGGOTA -->
      </v-row>
    </div>
    <v-dialog v-model="dialogAmbilData" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Ambil Data</v-card-title>
        <v-card-text>
          ⚠️ Data belum tersedia. Anda harus mengambil data terlebih dahulu untuk melanjutkan.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :loading="loadingAmbilData" @click="startDownload">Ambil Data</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="alert.show" :timeout="5000">
      {{ alert.msg }}
    </v-snackbar>
  </div>
</template>

<script>
import Toast from "@/components/Toast";
import { mapGetters, mapActions } from "vuex";
import services from "@/services";
import helper from "@/utils/helper";
import JadwalSholat from "../components/JadwalSholat/JadwalSholat.vue";
import { getData, saveData } from "@/utils/indexedDB";
import { downloadAndSaveData } from "@/utils/indexedDB";
export default {
  name: "Home",
  components: {
    Toast,
    JadwalSholat,
  },
  data() {
    return {
      watchId: null,
      geoAlertShown: false,
      dialogAmbilData: false,
      loadingAmbilData: false,
      form: {
        data: {
          latitude: 0,
          longitude: 0,
        },
      },
      kasPetugas: {
        saldoAwal: 0,
        saldoAkhir: 0,
        kasMasuk: 0,
        kasKeluar: 0,
      },
      pembiayaan: {
        pengajuan: 0,
        pencairan: 0,
      },
      tabungan: {
        pembukaan: 0,
        pencairan: 0,
      },
      anggota: {
        gabung: 0,
        keluar: 0,
      },
      alert: {
        show: false,
        msg: "",
      },
      progress: 0,
      isLoading: false,
      errorMessage: "",
      isDialogVisible: false,
    };
  },
  computed: {
    ...mapGetters(["user", "userRole"]),
  },

  methods: {
    ...helper,
    ...mapActions(["logout"]),
    async createdLogic() {
      const hasData = await this.cekDataIndexedDB();
      const sudahAmbilHariIni = this.cekSudahAmbilHariIni();

      console.log(sudahAmbilHariIni);

      if (!hasData || !sudahAmbilHariIni) {
        this.dialogAmbilData = true;
        return;
      }

      await this.updateAllData();
      await this.geoLocation();
    },

    cekSudahAmbilHariIni() {
      const lastFetch = localStorage.getItem("lastFetch");
      const today = new Date().toISOString().slice(0, 10);
      console.log("Last fetch:", lastFetch, "| Today:", today);

      if (!lastFetch || lastFetch !== today) {
        return false;
      }

      return true;
    },



    keluarApp() {
      this.dialogAmbilData = false;
      this.$router.push("/login");
    },
    async cekDataIndexedDB() {
      const count_anggota = await getData("count_anggota", "count_anggota");
      const count_pembiayaan = await getData("count_pembiayaan", "count_pembiayaan");
      const count_tabungan = await getData("count_tabungan", "count_tabungan");
      const kas_petugas = await getData("kas_petugas", "kas_petugas");
      const info_penagihan = await getData("info_penagihan", "info_penagihan");
      const info_tertunggak = await getData("info_tertunggak", "info_tertunggak");
      const list_penagihan = await getData("list_penagihan", "list_penagihan");
      if (!count_anggota || !count_pembiayaan || !count_tabungan || !kas_petugas || !info_penagihan || !info_tertunggak || !list_penagihan) {
        return false;
      }
      return true;
    },
    startDownload() {
      this.isLoading = true;
      this.isDialogVisible = true;
      this.progress = 0;
      this.errorMessage = "";

      downloadAndSaveData(
        this.user,
        (progressBar) => {
          this.$nextTick(() => {
            this.progress = progressBar * 100;
          });
        },
        (error) => {
          console.log("Gagal menyinkronkan data: " + error);
          this.errorMessage = "Gagal menyinkronkan data: " + error;
          this.isLoading = false;
        }
      );
    },

    async getSaldo() {
      try {
        const saldo = await getData("kas_petugas", "kas_petugas");
        const req = saldo?.data?.data;

        if (req?.status === true) {
          this.kasPetugas.saldoAwal = parseFloat(req.data?.saldo_awal || 0);
          this.kasPetugas.saldoAkhir = parseFloat(req.data?.saldo_akhir || 0);
          this.kasPetugas.kasMasuk = parseFloat(req.data?.kas_masuk || 0);
          this.kasPetugas.kasKeluar = parseFloat(req.data?.kas_keluar || 0);
        } else {
          const errorMsg = req?.data?.msg ?? "Unknown error";
          if (errorMsg.toLowerCase().includes("token")) {
            this.logout();
            await this.$router.push("/login");
            return;
          }
        }
      } catch (error) {
        console.error("Gagal mengambil saldo:", error);
      }
    },
    async getCountPembiayaan() {
      try {
        const count_pembiayaan = await getData("count_pembiayaan", "count_pembiayaan");
        const req = count_pembiayaan?.data?.data;
        if (req?.status === true) {
          this.pembiayaan.pengajuan = parseFloat(req.data?.pengajuan || 0);
          this.pembiayaan.pencairan = parseFloat(req.data?.pencairan || 0);
        } else {
          const errorMsg = req?.data?.msg ?? "Unknown error";
          if (errorMsg.toLowerCase().includes("token")) {
            this.logout();
            await this.$router.push("/login");
            return;
          }
        }
      } catch (error) {
        console.error("Gagal mengambil count pembiayaan:", error);
      }
    },
    async getCountTabungan() {
      try {
        const count_tabungan = await getData("count_tabungan", "count_tabungan");
        const req = count_tabungan?.data?.data;
        if (req?.status === true) {
          this.tabungan.pengajuan = parseFloat(req.data?.pembukaan || 0);
          this.tabungan.pencairan = parseFloat(req.data?.pencairan || 0);
        } else {
          const errorMsg = req?.data?.msg ?? "Unknown error";
          if (errorMsg.toLowerCase().includes("token")) {
            this.logout();
            await this.$router.push("/login");
            return;
          }
        }
      } catch (error) {
        console.error("Gagal mengambil count tabungan:", error);
      }
    },
    async getCountAnggota() {
      try {
        const count_anggota = await getData("count_anggota", "count_anggota");
        const req = count_anggota?.data?.data;
        if (req?.status === true) {
          this.anggota.pengajuan = parseFloat(req.data?.anggota_masuk || 0);
          this.anggota.pencairan = parseFloat(req.data?.anggota_keluar || 0);
        } else {
          const errorMsg = req?.msg ?? "Unknown error";
          if (errorMsg.toLowerCase().includes("token")) {
            this.logout();
            await this.$router.push("/login");
            return;
          }
        }
      } catch (error) {
        console.error("Gagal mengambil count anggota:", error);
      }
    },
    async handleSelesai() {
      this.isDialogVisible = false;
      this.dialogAmbilData = false;

      // Simpan tanggal hari ini ke localStorage
      localStorage.setItem("lastFetch", new Date().toISOString().slice(0, 10));

      // Panggil semua endpoint
      try {
        let payload = new FormData();
        payload.append("fa_code", this.user.fa_code);
        const req = await services.collectData(payload, this.user.token);
        const response = req.data;
        if (response?.status === true) {
          await this.getSaldo();
          await this.getCountPembiayaan();
          await this.getCountTabungan();
          await this.getCountAnggota();
        } else {
          this.showAlert("⚠️ Terjadi kesalahan pada server ambil data", "error");
          return;
        }
      } catch (error) {
        console.error("Gagal memuat data:", error);
      }
    },

    getDate() {
      let today = new Date();
      let day = today.getDate();
      let month = today.getMonth() + 1;
      let year = today.getFullYear();
      return `${year}-${month}-${day}`;
    },

    // DETEKSI GPS DAN UPDATE KE LOCALSTORAGE
    async geoLocation() {
      if (!navigator.geolocation) {
        this.showAlert("⚠️ Maaf, Browser Anda Tidak Mendukung", "warning");
        return;
      }

      try {
        const position = await this.getCurrentPosition();
        this.updateLocation(position);
      } catch (error) {
        const lastLocation = localStorage.getItem("lastLocation");
        if (lastLocation) {
          const parsed = JSON.parse(lastLocation);
          this.updateLocation({ coords: parsed });
        }
        this.handleGeoError(error);
      }

      if (!this.watchId) {
        this.watchId = navigator.geolocation.watchPosition(
          this.updateLocation,
          this.handleGeoError,
          { enableHighAccuracy: true }
        );
      }
    },

    getCurrentPosition() {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 3000,
          maximumAge: 0,
        });
      });
    },
    updateLocation(position) {
      this.form.data.latitude = position.coords.latitude;
      this.form.data.longitude = position.coords.longitude;

      // Simpan ke localStorage
      localStorage.setItem(
        "lastLocation",
        JSON.stringify({
          latitude: this.form.data.latitude,
          longitude: this.form.data.longitude,
        })
      );
    },

    handleGeoError(error) {
      if (this.geoAlertShown) return; // agar alert cuma sekali muncul
      this.geoAlertShown = true;

      let msg = "Gagal mendapatkan lokasi.";
      switch (error.code) {
        case error.PERMISSION_DENIED:
          msg = "Anda menolak akses lokasi. Silakan aktifkan izin lokasi di pengaturan.";
          if (this.watchId) {
            navigator.geolocation.clearWatch(this.watchId);
          }
          break;

        case error.POSITION_UNAVAILABLE:
          msg = "Lokasi tidak tersedia. Pastikan GPS Anda aktif.";
          break;

        case error.TIMEOUT:
          msg = "Pengambilan lokasi terlalu lama. Menggunakan lokasi terakhir yang tersedia.";
          break;
      }
      this.$store.dispatch("showAlert", { show: false });
      setTimeout(() => {
        this.$store.dispatch("showAlert", {
          show: true,
          msg: "⚠️" + " " + msg,
          color: "warning",
          position: "top",
        });
      }, 3000);

      if (!navigator.onLine) {
        getLastLocation();
        return;
      }

      navigator.geolocation.getCurrentPosition(this.updateLocation, this.handleGeoError, {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      });

      if (!this.watchId) {
        this.watchId = navigator.geolocation.watchPosition(this.updateLocation, this.handleGeoError, {
          enableHighAccuracy: true,
        });
      }
    },
    // END DETEKSI GPS

    // UPDATE KE LOCALSTORAGE
    async updateSaldoFromServer() {
      try {
        let payload = new FormData();
        payload.append("account_cash_code", this.user.account_cash_code);
        const req = await services.infoSaldoPetugas(payload, this.user.token);
        const response = req.data;
        if (response?.status === true) {
          await saveData("kas_petugas", req, "kas_petugas");
          this.getSaldo();
        }
      } catch (error) {
        console.error("Gagal update saldo dari server:", error);
      }
    },
    async updateCountPembiayaanFromServer() {
      try {
        let payload = new FormData();
        payload.append("fa_code", this.user.fa_code);
        const req = await services.infoFinancing(payload, this.user.token);
        const response = req.data;
        if (response?.status === true) {
          await saveData("count_pembiayaan", req, "count_pembiayaan");
          this.getCountPembiayaan();
        }
      } catch (error) {
        console.error("Gagal update count pembiayaan dari server:", error);
      }
    },
    async updateCountTabunganFromServer() {
      try {
        let payload = new FormData();
        payload.append("fa_code", this.user.fa_code);
        const req = await services.infoSaving(payload, this.user.token);
        const response = req.data;
        if (response?.status === true) {
          await saveData("count_tabungan", req, "count_tabungan");
          this.getCountTabungan();
        }
      } catch (error) {
        console.error("Gagal update count tabungan dari server:", error);
      }
    },
    async updateCountAnggotaFromServer() {
      try {
        let payload = new FormData();
        payload.append("account_cash_code", this.user.account_cash_code);
        const req = await services.infoSaldoPetugas(payload, this.user.token);
        const response = req.data;
        if (response?.status === true) {
          await saveData("count_anggota", req, "count_anggota");
          this.getCountAnggota();
        }
      } catch (error) {
        console.error("Gagal update count anggota dari server:", error);
      }
    },

    async updateAllData() {
      if (navigator.onLine) {
        this.updateSaldoFromServer();
        this.updateCountPembiayaanFromServer();
        this.updateCountTabunganFromServer();
        this.updateCountAnggotaFromServer();
      }
    },

    handleOnline() {
      this.updateAllData();
    },
    // END UPDATE KE LOCALSTORAGE

    showAlert(msg, color = "warning") {
      this.$store.dispatch("showAlert", {
        show: true,
        msg,
        color,
        position: "top",
      });
    },
  },

  async created() {
    this.createdLogic();
    // const hasData = await this.cekDataIndexedDB();
    // if (!hasData) return this.showAlert("⚠️ Data belum tersedia. Silakan unduh terlebih dahulu.", "warning");();
  },
  mounted() {
    this.onlineHandler = this.handleOnline;
    this.geoLocation();
    window.addEventListener("online", this.onlineHandler);
  },

  beforeDestroy() {
    window.removeEventListener("online", this.onlineHandler);
    if (this.watchId) {
      navigator.geolocation.clearWatch(this.watchId);
    }
  },
};
</script>
<style scoped>
.bg-gradient {
  background-size: 180% 180%;
  background-image: linear-gradient(145deg, rgba(103, 33, 120, 0.9), rgba(103, 33, 120, 0.7), rgba(103, 33, 120, 0.5), rgba(103, 33, 120, 0.3));
  /* animation: gradientMove 10s ease-in-out infinite; */
}

.neumorphic-btn {
  border-radius: 12px;
  box-shadow: inset 6px 6px 12px rgba(0, 0, 0, 0.3), inset -6px -6px 12px rgba(255, 255, 255, 0.1);
}

.neumorphic-btn:active {
  box-shadow: inset 8px 8px 16px rgba(0, 0, 0, 0.4), inset -8px -8px 16px rgba(255, 255, 255, 0.2);
  transform: scale(0.98);
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }

  25% {
    background-position: 50% 75%;
  }

  50% {
    background-position: 100% 50%;
  }

  75% {
    background-position: 50% 25%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.card-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  padding: 16px 24px;
  font-family: Arial, sans-serif;
}

.card-item {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.card-item:not(:last-child) {
  border-right: 2px solid #9a9a9a;
  padding-right: 12px;
}

.card-icon {
  width: 40px;
  height: 40px;
}

.card-text {
  font-size: 13px;
}

.card-value {
  font-size: 16px;
  font-weight: bold;
}
</style>
